import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpListUseInfoPopup from './corp-list-use-info-popup';
import CorpListStore from './corp-list-store';
import moment from 'moment';

const CorpListUseInfoPopupContainer = () => {
  // console.log('CorpListUseInfoPopupContainer Load');

  const { useInfoList, visibleUseInfoPopup } = CorpListStore;

  const [useInfo, setUseInfo, startDate, endDate] = useState({
    FromDate: moment().add(-3, 'months').format('YYYYMMDD'),
    ToDate: moment().add(-1, 'days').format('YYYYMMDD'),
    startDate: moment().add(-3, 'months').format('YYYYMMDD'),
    endDate: moment().add(-1, 'days').format('YYYYMMDD'),
  });

  useEffect(() => {
    // console.log('CorpListUseInfoPopupContainer > useEffect()');
  }, [useInfoList, visibleUseInfoPopup]);

  const onValueChanged = useCallback((name, e) => {
    const { value, event } = e;
    let isDate = false;
    //console.log('onValueChanged event :::', e);

    if (name === 'FromDate' || name === 'ToDate') {
      if (event) {
        isDate = true;
      } else {
        return;
      }
    }

    console.log(
      `onValueChanged - name : ${name}, value : ${
        isDate ? moment(value).format('YYYYMMDD') : value
      }`
    );

    setUseInfo((useInfo) => ({
      ...useInfo,
      [name]: isDate ? moment(value).format('YYYYMMDD') : value,
    }));
  }, []);

  const onStartDateChange = useCallback((e) => {
    console.log('onStartDateChange event :::', e);
    const date = moment(e).format('YYYYMMDD');

    useInfo.startDate = date;
    //console.log(useInfo.startDate);
  });

  const onEndDateChange = useCallback((e) => {
    //console.log('onValueChanged event :::', e);
    const date = moment(e).format('YYYYMMDD');

    useInfo.endDate = date;
    //console.log(useInfo.endDate);
  });

  function getFormatDate(date){
      var year = date.getFullYear();              //yyyy
      var month = (1 + date.getMonth());          //M
      month = month >= 10 ? month : '0' + month;  //month 두자리로 저장
      var day = date.getDate();                   //d
      day = day >= 10 ? day : '0' + day;          //day 두자리로 저장
      return  year + '' + month + '' + day;       //'-' 추가하여 yyyy-mm-dd 형태 생성 가능
  }

  const onChange = useCallback((name, date) => {
    //console.log('onChange event :::', getFormatDate(date));
    let isDate = false;
    if (['startDate','endDate'].includes(name)) {
      isDate = true;
    } else {
      return;
    }

    setUseInfo((useInfo) => ({
      ...useInfo,
      [name]: isDate ? getFormatDate(date) : date,
    }));

  }, []);

  const onClickSearch = useCallback(async () => {
    const result = await CorpListStore.getUseInfoList(
      '',
      3,
      useInfo.startDate,
      useInfo.endDate,
    );

    // console.log(useInfo.startDate);
    // console.log(useInfo.endDate);

    if (result.error) {
      alert(result.message);
    }
  }, [useInfo]);

  if (!useInfo) {
    return;
  }

  return (
    <CorpListUseInfoPopup
      onValueChanged={onValueChanged}
      onHiding={() => CorpListStore.setVisibleUseInfoPopup(false)}
      onClickSearch={onClickSearch}
      useInfo={useInfo}
      useInfoList={useInfoList}
      visibleUseInfoPopup={visibleUseInfoPopup}
      onChange={onChange}
      onDateChange={onStartDateChange}
      onDateChangeEnd={onEndDateChange}
    />
  );
};

export default React.memo(observer(CorpListUseInfoPopupContainer));
